import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';

const { array, func, object, string } = PropTypes;

import Bar from '../widgets/bar';

const getPercentage = (total, compare) => (compare / total);

class SentItems extends Component {
  onItemClick = (label) => {
    const { data } = this.props;
    const clickedItem = data
      .filter(d => d.label === label)
      .reduce((a, b) => { return b.label; }, '');
    switch (clickedItem) {
      case 'bounce':
        this.goToContractList('bounced');
        break;
      case 'delivered':
        this.goToContractList('delivered');
        break;
      case 'open':
        this.goToContractList('opened');
        break;
      default:
    }
  }

  goToContractList = (filter) => {
    this.props.push({
      pathname: '/contracting/contract-list/search',
      query: {
        openAdvanceSearch: true,
        searchCategory: 'all contracts',
        searchingAllYears: false,
        [this.props.companyType === 'Contractor' ? 'stateFilterForBuyer' : 'stateFilterForSupplier']: ['sent'],
        sentFilter: [filter],
      },
    });
  }

  render() {
    const { data } = this.props;
    const processed = data.filter(d => d.label === 'processed')[0].value;
    return (<div>
      {
        data.filter(d => d.label !== 'processed').map((d, i) => {
          const percent = d.value > 0 ? Math.round(getPercentage(processed, d.value) * 100) : 0;
          return <Bar key={i} label={d.label} percent={percent} value={d.value || 0} onItemClick={this.onItemClick} />;
        })
      }
    </div>);
  }
}
SentItems.propTypes = {
  data: array,
  push: func,
  style: object,
  companyType: string,
};

export default connect(({ user }) => ({
  companyType: user.getIn(['company', 'companyType']),
}), ({
  push,
}))(SentItems);



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/charts/sentItems.jsx